import React, { useState } from "react";
import { Search, Zap, Layers, CheckCircle, XCircle, Package } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";

const ProductFinder = () => {
  const [lampType, setLampType] = useState("");
  const [application, setApplication] = useState("");
  const [substrate, setSubstrate] = useState("");
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);

  // Updated product database from Google Sheet (Dec 2025) - 83 products
  const productDatabase = [
    { code: "2377", name: "HERMETIC LED CAST AND CURE SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2392", name: "HERMETIC LED COLD FOIL SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2386", name: "HERMETIC LED SPOT SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2391", name: "HERMETIC LED EMBOSS SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2376", name: "HERMETIC LED HOT FOIL (SEMI AUTO) SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2335", name: "HERMETIC LED GLOSS RC FOR MATTE TEXTURE COATING", lamp: "LED", apps: ["Screen", "Offset"], substrates: ["Paper"] },
    { code: "2408", name: "HERMETIC LED MATTE TEXTURE SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2409", name: "HERMETIC LED SAND TEXTURE SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2371", name: "HERMETIC LED COATING FOR MET - PET", lamp: "LED", apps: ["Gravure"], substrates: ["Metallised Polyester"] },
    { code: "2372", name: "HERMETIC UV COATING FOR WATER BASE INKS", lamp: "UV", apps: ["Gravure"], substrates: ["Paper"] },
    { code: "2380", name: "HERMETIC LED COLD FOIL SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Polycarbonate Sheet"] },
    { code: "2383", name: "HERMETIC LED SINGLE TEXTURE GRAVURE COATING", lamp: "LED", apps: ["Security (Gravure)"], substrates: ["Paper"] },
    { code: "2384", name: "HERMETIC LED COPPER GLITTER GRAVURE COATING", lamp: "LED", apps: ["Security (Gravure)"], substrates: ["Paper"] },
    { code: "2385", name: "HERMETIC LED MATTE GRAVURE (GLOSS 25-40) COATING", lamp: "LED", apps: ["Gravure"], substrates: ["Paper"] },
    { code: "2387", name: "HERMETIC UV GLOSS PVC COATING", lamp: "UV", apps: ["Roller Coater"], substrates: ["PVC"] },
    { code: "2388", name: "HERMETIC UV COLD FOIL DECKLE PAPER COATING", lamp: "UV", apps: ["Roller Coater"], substrates: ["Deckle Paper"] },
    { code: "2389", name: "HERMETIC LED HIGH SPEED HIGH GLOSS SPEED 300 GRAVURE COATING", lamp: "LED", apps: ["Gravure"], substrates: ["Paper"] },
    { code: "2393", name: "HERMETIC UV FOR METAL SHEETS HIGH VISCOSITY", lamp: "UV", apps: ["Roller Coater"], substrates: ["Metal Sheets"] },
    { code: "2394", name: "HERMETIC UV FOR MET-PET COATING", lamp: "UV", apps: ["Gravure"], substrates: ["Metallised Polyester"] },
    { code: "2403", name: "HERMETIC UV FOR MET-PET COATING ( W/ O FOIL WASH )", lamp: "UV", apps: ["Gravure"], substrates: ["Metallised Polyester"] },
    { code: "2416", name: "HERMETIC LED COLD FOIL GRAVURE COATING", lamp: "LED", apps: ["Security (Gravure)"], substrates: ["Paper"] },
    { code: "2417", name: "HERMETIC LED CAST N CURE GRAVURE COATING", lamp: "LED", apps: ["Security (Gravure)"], substrates: ["Paper"] },
    { code: "2419", name: "HERMETIC LED CRYSTAL SCREEN COATING", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2420", name: "LERMETIC LED ORANGE PEEL SCREEN COATING", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2421", name: "HERMETIC LED DEAD MATTE GRAVURE POROS PAPER COATING", lamp: "LED", apps: ["Gravure"], substrates: ["Paper"] },
    { code: "2422", name: "HERMETIC LED HIGH GLOSS GRAVURE COATING", lamp: "LED", apps: ["Gravure"], substrates: ["Paper"] },
    { code: "2425", name: "HERMETIC LED HOT FOIL GRAVURE COATING", lamp: "LED", apps: ["Security (Gravure)"], substrates: ["Paper"] },
    { code: "2373", name: "HERMETIC LED GLOW IN DARK SCREEN SECURITY COATING (YELLOW)", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2405", name: "HERMETIC LED THERMOCHROMIC SCREEN SECURITY COATING", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2406", name: "HERMETIC LED PHOTOCHROMIC SCREEN SECURITY COATING", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2407", name: "HERMETIC LED INVISIBLE INK SCREEN SECURITY COATING", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2333", name: "HERMETIC LED DUCT MATTE TEXTURE COATING", lamp: "LED", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2334", name: "HERMETIC LED DUCT GLOSS FOR MATTE TEXTURE COATING", lamp: "LED", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2354", name: "HERMETIC LED DUCT DEAD MATTE COATING", lamp: "LED", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2355", name: "HERMETIC LED COATER DEAD MATTE COATING", lamp: "LED", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2339", name: "HERMETIC LED COATER HIGH GLOSS & HIGH SLIP COATING", lamp: "LED", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2357", name: "HERMETIC LED COATER SOFT FEEL COATING", lamp: "LED", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2374", name: "HERMETIC UV MATTE TEXTURE SCREEN COATING", lamp: "UV", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2375", name: "HERMETIC UV GLOSS RC FOR MATTE TEXTURE COATING", lamp: "UV", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2382", name: "HERMETIC UV SPOT SCREEN COATING", lamp: "UV", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2390", name: "HERMETIC UV EMBOSS SCREEN COATING", lamp: "UV", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2410", name: "HERMETIC UV COLD FOIL SCREEN COATING", lamp: "UV", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2378", name: "HERMETIC UV HOT FOIL (SEMI AUTO) SCREEN COATING", lamp: "UV", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2379", name: "HERMETIC UV SAND SCREEN COATING", lamp: "UV", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2411", name: "HERMETIC UV CAST AND CURE SCREEN COATING", lamp: "UV", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2412", name: "HERMETIC UV GLOW IN DARK SCREEN SECURITY COATING", lamp: "UV", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2413", name: "HERMETIC UV THERMOCHROMIC SCREEN SECURITY COATING", lamp: "UV", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2414", name: "HERMETIC UV PHOTOCHROMIC SCREEN SECURITY COATING", lamp: "UV", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2415", name: "HERMETIC UV INVISIBLE INK SCREEN SECURITY COATING", lamp: "UV", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2330", name: "HERMETIC UV DUCT MATTE TEXTURE COATING", lamp: "UV", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2331", name: "HERMETIC UV DUCT GLOSS FOR MATTE TEXTURE COATING", lamp: "UV", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2336", name: "HERMETIC UV RC GLOSS FOR MATTE TEXTURE COATING", lamp: "UV", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2358", name: "HERMETIC UV COATER DEAD MATTE COATING", lamp: "UV", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2353", name: "HERMETIC UV DUCT DEAD MATTE COATING", lamp: "UV", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2313", name: "HERMETIC UV COATER HIGH GLOSS & HIGH SLIP COATING", lamp: "UV", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2323", name: "HERMETIC UV COATER HIGH GLOSS COATING", lamp: "UV", apps: ["Offset"], substrates: ["Paper"] },
    { code: "2369", name: "HERMETIC UV PVC COATER HIGH GLOSS COATING", lamp: "UV", apps: ["Offset"], substrates: ["PVC"] },
    { code: "2370", name: "HERMETIC UV FOR RC METAL SHEETS COATING", lamp: "UV", apps: ["Offset"], substrates: ["Metal Sheets"] },
    { code: "2367", name: "HERMETIC LED MATTE TEXTURE FLEXO COATING", lamp: "LED", apps: ["Flexo"], substrates: ["Paper"] },
    { code: "2362", name: "HERMETIC LED GLOSS TEXTURE FLEXO COATING", lamp: "LED", apps: ["Flexo"], substrates: ["Paper"] },
    { code: "2381", name: "HERMETIC LED CAST N CURE SCREEN FOR PC COATING", lamp: "LED", apps: ["Screen"], substrates: ["Polycarbonate Sheet"] },
    { code: "2327", name: "HERMETIC UV HIGH GLOSS HIGH SPEED GRAVURE COATING", lamp: "UV", apps: ["Gravure"], substrates: ["Paper"] },
    { code: "2426", name: "Hermetic LED Gold Glitter Screen Coating (Porous)", lamp: "LED", apps: ["Screen"], substrates: ["Porous Paper"] },
    { code: "2396", name: "HERMETIC LED GLITTER BASE SCREEN FOR POROUS PAPER", lamp: "LED", apps: ["Screen"], substrates: ["Porous Paper"] },
    { code: "2418", name: "HERMETIC LED CAST N CURE SCREEN FOR GLOSS THERMAL LAMINATION", lamp: "LED", apps: ["Screen"], substrates: ["Thermal Film"] },
    { code: "2427", name: "HERMETIC LED GLOW IN DARK SCREEN SECURITY COATING (BLUE)", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2428", name: "Flexibity Additive for Screen Paper", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2429", name: "HERMETIC LED GLITTER BASE SCREEN FOR PAPER", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2430", name: "HERMETIC LED GLOW IN DARK SCREEN SECURITY COATING (VIOLET)", lamp: "LED", apps: ["Glow In Dark", "Security (Screen)"], substrates: ["Paper"] },
    { code: "2431", name: "Viscosity Thickener for Glow in Dark and Glitter Paper", lamp: "LED", apps: ["Screen"], substrates: ["Paper"] },
    { code: "2432", name: "HERMETIC UV COATER FOR ACRYLIC SHEET COATING", lamp: "UV", apps: ["Roller Coater"], substrates: ["Polycarbonate Sheet"] },
    { code: "2433", name: "HERMETIC LED CAST AND CURE SCREEN COATING (200 MESH)", lamp: "LED", apps: ["Screen"], substrates: ["Carton Box"] },
    { code: "2434", name: "HERMETIC UV HOT FOIL SCREEN COATING (120 MESH)", lamp: "UV", apps: ["Screen"], substrates: ["Carton Box"] },
    { code: "2435", name: "HERMETIC UV SPOT SCREEN COATING (140 MESH)", lamp: "UV", apps: ["Screen"], substrates: ["Carton Box"] },
    { code: "2436", name: "HERMETIC UV EMBOSS SCREEN COATING (120 MESH)", lamp: "UV", apps: ["Screen"], substrates: ["Carton Box"] },
    { code: "2437", name: "HERMETIC LED GLOW IN DARK SCREEN SECURITY COATING (SKY BLUE)", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2438", name: "HERMETIC LED GLOW IN DARK SCREEN SECURITY COATING (GREEN)", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2439", name: "HERMETIC LED GLOW IN DARK SCREEN SECURITY COATING (ORANGE)", lamp: "LED", apps: ["Security (Screen)"], substrates: ["Paper"] },
    { code: "2440", name: "HERMETIC LED CAST AND CURE SCREEN COATING (200 MESH)/WB PRIMER", lamp: "LED", apps: ["Screen"], substrates: ["Carton Box"] },
    { code: "2441", name: "Flexibility Additive for Metal Sheet 2370", lamp: "UV", apps: ["Roller Coater"], substrates: ["Metal Sheets"] },
    { code: "2442", name: "HERMETIC UV FOR RC METAL SHEETS COATING (WHITE BACK)", lamp: "UV", apps: ["Roller Coater"], substrates: ["Metal Sheets"] },
    { code: "2332", name: "HERMETIC UV CAST N CURE GRAVURE COATING", lamp: "UV", apps: ["Gravure"], substrates: ["Paper"] }
  ];

  const handleSearch = () => {
    if (!lampType || !application || !substrate) {
      return;
    }

    const filtered = productDatabase.filter(product => 
      product.lamp === lampType && 
      product.apps.includes(application) && 
      product.substrates.includes(substrate)
    );

    setResults(filtered);
    setSearched(true);
  };

  const handleReset = () => {
    setLampType("");
    setApplication("");
    setSubstrate("");
    setResults([]);
    setSearched(false);
  };

  return (
    <section id="product-finder" className="section-padding bg-white reveal">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#8B1538] font-semibold text-sm uppercase tracking-wider">Smart Search</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Product Finder
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Find the perfect coating solution for your specific requirements. Select lamp type, application process, and substrate to get instant product recommendations.
          </p>
        </div>

        {/* Search Interface */}
        <div className="max-w-6xl mx-auto">
          <Card className="border-2 border-gray-200 shadow-xl">
            <CardHeader className="bg-gradient-to-r from-red-50 to-white border-b">
              <CardTitle className="flex items-center text-2xl">
                <Search className="h-6 w-6 text-[#8B1538] mr-3" />
                Select Your Requirements
              </CardTitle>
            </CardHeader>
            <CardContent className="p-8">
              <div className="grid lg:grid-cols-3 gap-8 mb-8">
                {/* Category 1: Lamp Type */}
                <div>
                  <label className="flex items-center text-lg font-bold text-gray-900 mb-4">
                    <Zap className="h-5 w-5 text-[#8B1538] mr-2" />
                    Category 1: Lamp Type
                  </label>
                  <div className="space-y-3">
                    {["UV", "LED"].map((type) => (
                      <button
                        key={type}
                        onClick={() => setLampType(type)}
                        className={`w-full p-4 rounded-lg border-2 transition-all duration-200 text-left ${
                          lampType === type
                            ? "border-[#8B1538] bg-red-50 shadow-md"
                            : "border-gray-200 hover:border-[#8B1538] hover:bg-gray-50"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span className="font-semibold text-gray-900">{type} Lamp</span>
                          {lampType === type && <CheckCircle className="h-5 w-5 text-[#8B1538]" />}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Category 2: Application Process */}
                <div>
                  <label className="flex items-center text-lg font-bold text-gray-900 mb-4">
                    <Layers className="h-5 w-5 text-[#8B1538] mr-2" />
                    Category 2: Application
                  </label>
                  <div className="space-y-2 max-h-[450px] overflow-y-auto pr-2">
                    {[
                      { label: "Screen", value: "Screen" },
                      { label: "Offset", value: "Offset" },
                      { label: "Gravure", value: "Gravure" },
                      { label: "Security (Screen)", value: "Security (Screen)" },
                      { label: "Flexo", value: "Flexo" },
                      { label: "Roller Coater", value: "Roller Coater" },
                      { label: "Security (Gravure)", value: "Security (Gravure)" },
                      { label: "Glow In Dark", value: "Glow In Dark" }
                    ].map((app) => (
                      <button
                        key={app.value}
                        onClick={() => setApplication(app.value)}
                        className={`w-full p-2.5 rounded-lg border-2 transition-all duration-200 text-left ${
                          application === app.value
                            ? "border-[#8B1538] bg-red-50 shadow-md"
                            : "border-gray-200 hover:border-[#8B1538] hover:bg-gray-50"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span className="font-semibold text-gray-900 text-xs">{app.label}</span>
                          {application === app.value && <CheckCircle className="h-4 w-4 text-[#8B1538]" />}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Category 3: Substrate */}
                <div>
                  <label className="flex items-center text-lg font-bold text-gray-900 mb-4">
                    <Package className="h-5 w-5 text-[#8B1538] mr-2" />
                    Category 3: Substrate
                  </label>
                  <div className="space-y-3 max-h-[450px] overflow-y-auto pr-2">
                    {["Paper", "Metallised Polyester", "PVC", "Metal Sheets", "Polycarbonate Sheet", "Deckle Paper", "Porous Paper", "Thermal Film", "Carton Box"].map((sub) => (
                      <button
                        key={sub}
                        onClick={() => setSubstrate(sub)}
                        className={`w-full p-3 rounded-lg border-2 transition-all duration-200 text-left ${
                          substrate === sub
                            ? "border-[#8B1538] bg-red-50 shadow-md"
                            : "border-gray-200 hover:border-[#8B1538] hover:bg-gray-50"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span className="font-semibold text-gray-900 text-sm">{sub}</span>
                          {substrate === sub && <CheckCircle className="h-4 w-4 text-[#8B1538]" />}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4">
                <Button
                  onClick={handleSearch}
                  disabled={!lampType || !application || !substrate}
                  className="flex-1 bg-[#8B1538] hover:bg-[#DC143C] text-white py-6 text-lg font-semibold disabled:bg-gray-300 disabled:cursor-not-allowed"
                >
                  <Search className="mr-2 h-5 w-5" />
                  Find Products
                </Button>
                {searched && (
                  <Button
                    onClick={handleReset}
                    variant="outline"
                    className="border-2 border-[#8B1538] text-[#8B1538] hover:bg-red-50 py-6 px-8 text-lg font-semibold"
                  >
                    Reset
                  </Button>
                )}
              </div>
            </CardContent>
          </Card>

          {/* Results Section */}
          {searched && (
            <div className="mt-8">
              {results.length > 0 ? (
                <Card className="border-2 border-green-200 shadow-xl">
                  <CardHeader className="bg-gradient-to-r from-green-50 to-white border-b">
                    <CardTitle className="flex items-center text-2xl text-green-800">
                      <CheckCircle className="h-6 w-6 mr-3" />
                      Found {results.length} Product{results.length > 1 ? "s" : ""}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-6">
                    <div className="space-y-4">
                      {results.map((product, index) => (
                        <div
                          key={index}
                          className="p-4 bg-white border-2 border-gray-200 rounded-lg hover:border-[#8B1538] hover:shadow-md transition-all"
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <div className="flex items-center gap-3 mb-2 flex-wrap">
                                <span className="bg-[#8B1538] text-white px-4 py-1 rounded-full font-bold text-lg">
                                  {product.code}
                                </span>
                                <span className="text-xs bg-gray-100 px-3 py-1 rounded-full font-semibold text-gray-600">
                                  {lampType} Lamp
                                </span>
                                <span className="text-xs bg-blue-100 px-3 py-1 rounded-full font-semibold text-blue-600">
                                  {application}
                                </span>
                                <span className="text-xs bg-purple-100 px-3 py-1 rounded-full font-semibold text-purple-600">
                                  {substrate}
                                </span>
                              </div>
                              <p className="text-gray-800 font-medium">{product.name}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-500 rounded">
                      <p className="text-sm text-blue-800">
                        <strong>Note:</strong> For detailed technical specifications, application guidelines, or to place an order, please contact our sales team.
                      </p>
                    </div>
                  </CardContent>
                </Card>
              ) : (
                <Card className="border-2 border-yellow-200 shadow-xl">
                  <CardHeader className="bg-gradient-to-r from-yellow-50 to-white border-b">
                    <CardTitle className="flex items-center text-2xl text-yellow-800">
                      <XCircle className="h-6 w-6 mr-3" />
                      No Products Available
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-6">
                    <p className="text-gray-700">
                      We currently don't have {lampType} lamp coatings for {application} applications on {substrate} substrate in our standard product line. Please contact us for custom formulation options.
                    </p>
                    <Button
                      onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                      className="mt-4 bg-[#8B1538] hover:bg-[#DC143C] text-white"
                    >
                      Contact Us for Custom Solutions
                    </Button>
                  </CardContent>
                </Card>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProductFinder;
